import React from "react";
import ReactDragList from "react-drag-list";
import { getFieldName } from "./Utils";
import MPSSelect from "../../../../components/MPSSelect";
import Select from "react-select";
import { Input } from "reactstrap";
import LocationForm from "../../../../Shared/Facility/FacilityInfo/LocationForm";
import ModalPopup from "../../../../components/ModalPopup";
import MPSButton from "../../../../components/Buttons/Buttons/MPSButton";
import MPSTooltip from "../../../../components/MPSToolTip";

class AttributesSelector extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showLocationForm: false,
      locationIndex: null,
    };
  }

  onSort = (event, sorted) => {
    this.props.saveAttributes([...sorted]);
  };

  parseOptionsForDropDown = (options, type) => {
    let valueField = getFieldName(type);
    if (type === "CODEABLE_CONCEPT_CODE") {
      return options
        .filter((option) => option.valueCode)
        .map((option) => {
          return {
            value: option.valueCode.code,
            label: option.valueCode.display,
          };
        });
    }
    return options.map((option) => {
      return {
        value: option[valueField],
        label: option[valueField],
      };
    });
  };

  getFilterFieldFromAttribute = (index, attribute) => {
    let { type, choiceList, options, showAsCheckbox, valueLocation } =
      attribute;
    let fieldType = type === "DATE" ? "date" : "text";
    let valueField = getFieldName(type);
    if (choiceList && options && options.length >= 1) {
      if (showAsCheckbox) {
        return (
          <div className="d-flex">
            {options.map((option, index) => (
              <div
                key={`${option[valueField]}-${index}`}
                className={`d-flex align-items-center ${
                  index > 0 ? "ml-3" : ""
                }`}
              >
                <span style={{ fontSize: "0.9rem" }}>
                  {option[valueField]}{" "}
                </span>
                <input
                  style={{ height: "15px", width: "15px" }}
                  className="ml-1"
                  type="checkbox"
                  onChange={(e) => {
                    if (e.target.checked) {
                      attribute[valueField] = option[valueField];
                    } else {
                      attribute[valueField] = "";
                    }
                    this.onChangeField(index, attribute);
                  }}
                  checked={attribute[valueField] === option[valueField]}
                />
              </div>
            ))}
          </div>
        );
      }

      return (
        <Select
          value={attribute[valueField]}
          onChange={(option) => {
            attribute[valueField] = option ? option.value : null;
            this.onChangeField(index, attribute);
          }}
          options={this.parseOptionsForDropDown(options, type)}
        />
      );
    }

    if (type === "BOOLEAN") {
      return (
        <select
          style={{ border: "1px solid #cccccc", width: "100%" }}
          className="form-control"
          value={attribute[valueField]}
          onChange={(e) => {
            attribute[valueField] = e.target.value;
            this.onChangeField(index, attribute);
          }}
        >
          <option value={true}>Yes</option>
          <option value={false}>No</option>
        </select>
      );
    }

    if (type === "LOCATION") {
      return valueLocation ? (
        <div
          className="list-group-item list-group-item-action d-flex flex-row justify-content-between"
          key={index}
        >
          <div className="mx-2">
            <span>
              {valueLocation.telecom &&
                valueLocation.telecom[0] &&
                valueLocation.telecom[0].value}
            </span>
            &nbsp;|&nbsp;
            <span>
              {valueLocation.telecom &&
                valueLocation.telecom[1] &&
                valueLocation.telecom[1].value}
            </span>
            &nbsp;|&nbsp;
            <span>
              {valueLocation.address && valueLocation.address.line?.join(", ")}
            </span>
            ,&nbsp;
            <span>{valueLocation.address && valueLocation.address.city}</span>
            ,&nbsp;
            <span>
              {valueLocation.address && valueLocation.address.country}
            </span>
            {valueLocation.position && (
              <span>
                &nbsp;|&nbsp;
                {valueLocation.position &&
                  "Lat: " + valueLocation.position.latitude}
              </span>
            )}
            {valueLocation.position && (
              <span>
                ,&nbsp;
                {valueLocation.position &&
                  "Lng: " + valueLocation.position.longitude}
              </span>
            )}
          </div>

          <div className="mx-4 text-right">
            <MPSButton
              type="link"
              className="mx-2"
              onClick={() => this.onRemoveLocation(index)}
            >
              Remove
            </MPSButton>
          </div>
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center", height: 35 }}>
          <a
            href="#"
            onClick={() =>
              this.setState({ showLocationForm: true, locationIndex: index })
            }
          >
            Add Location.
          </a>
        </div>
      );
    }

    return (
      <Input
        key="input-key"
        style={{ border: "1px solid #cccccc", borderRadius: "4px" }}
        className="form-control"
        type={fieldType}
        autoCapitalize="sentences"
        value={attribute[valueField]}
        onMouseDown={(e) => {
          e.stopPropagation();
          console.log("moused down into text field");
        }}
        onClick={(e) => {
          e.stopPropagation();
          console.log("clicked into text field");
        }}
        onChange={(e) => {
          console.log("changed value in text field");
          attribute[valueField] = e.target.value;
          this.onChangeField(index, attribute);
        }}
      />
    );
  };

  onChangeField = (index, attribute) => {
    let { attributes } = this.props;
    // Find by code, not by index, since we're displaying filtered list
    let aIndex = attributes.findIndex(
      (a) => a.code.code === attribute.code.code
    );
    attributes[aIndex] = { ...attribute };
    
    this.props.saveAttributes([...attributes]);
  };

  onChangeLocation = (location) => {
    const { locationIndex } = this.state;
    let newAttributes = [...this.props.attributes];
    newAttributes[locationIndex] = {
      ...newAttributes[locationIndex],
      valueLocation: location,
    };

    this.props.saveAttributes([...newAttributes]);
    this.setState({ showLocationForm: false });
  };

  onRemoveLocation = (index) => {
    let newAttributes = [...this.props.attributes];
    delete newAttributes[index].valueLocation;

    this.props.saveAttributes([...newAttributes]);
  };

  render() {
    let {
      availableAttributes = [],
      attributes = [],
      saveAttributes,
      noNewAddition,
      containerStyle,
      containerClass,
      hideInternal,
    } = this.props;

    // Filter out internal attributes for display only
    let visibleAttributes = attributes;
    if (hideInternal) {
      visibleAttributes = visibleAttributes.filter((attr) => !attr.isInternal);
    }

    return (
      <div
        className={`${containerClass ? containerClass : ""} d-flex flex-column`}
        style={containerStyle}
      >
        <div>
          {!noNewAddition && (
            <MPSSelect
              style={{
                borderBottomLeftRadius: visibleAttributes.length >= 1 ? 0 : 4,
                borderBottomRightRadius: visibleAttributes.length >= 1 ? 0 : 4,
              }}
              options={availableAttributes.filter(
                (a) =>
                  attributes.findIndex((b) => b.code.code === a.code.code) ===
                  -1
              )}
              onChange={(options) => {
                let cloned = [...attributes, ...options];
                saveAttributes(cloned);
              }}
              multi
            />
          )}
        </div>

        {visibleAttributes.length >= 1 && (
          <div
            className="py-1"
            style={{
              border: "1px solid #cccccc",
              borderTop: noNewAddition ? "1px solid #cccccc" : 0,
              ...(noNewAddition
                ? { borderRadius: 4 }
                : {
                    borderBottomLeftRadius: 4,
                    borderBottomRightRadius: 4,
                  }),
            }}
          >
            {this.props.isRecurranceSeries && this.state.showFormula && (
              <div className="mx-3">
                <span>{this.state.formula}</span>
              </div>
            )}
            <ReactDragList
              disabled={this.props.disabled}
              ghostClass="dragGhost"
              dataSource={visibleAttributes}
              onUpdate={(event, sorted) => {
                // Only merge with internal attributes if we're hiding them
                if (hideInternal) {
                  const internalAttributes = attributes.filter(
                    (attr) => attr.isInternal
                  );
                  this.props.saveAttributes([...sorted, ...internalAttributes]);
                } else {
                  // If not hiding internal, just save the sorted list as-is
                  this.props.saveAttributes([...sorted]);
                }
              }}
              row={(attribute, index) => {
                let { type, editable } = attribute;
                let valueField = getFieldName(type);
                let value = attribute[valueField];
                if (!this.props.template) {
                  if (!value && !editable) {
                    return null;
                  }
                  if (!editable && this.props.hideReadOnly) {
                    return null;
                  }
                }
                return (
                  <div
                    className="d-flex mx-1 justify-content-between align-items-start"
                    style={{
                      padding: "0 0.5rem",
                      borderBottom: 0,
                      // borderBottom: this.props.disabled
                      //   ? 0
                      //   : "1px solid #cccccc",
                      fontSize: "0.76562rem",
                      marginBottom: "2px",
                    }}
                  >
                    <div
                      style={{ width: "40%", fontSize: "0.9rem" }}
                      className="d-flex"
                    >
                      <div className="text-muted">{attribute.code.display}</div>
                      {attribute.description && (
                        <div className="ml-2">
                          <MPSTooltip
                            id={`attribute-${index}`}
                            className="mr-2"
                          >
                            {attribute.description}
                          </MPSTooltip>
                        </div>
                      )}
                    </div>
                    <div
                      className="d-flex align-items-center "
                      style={{
                        width: "60%",
                      }}
                    >
                      <div className="d-flex" style={{ width: "90%" }}>
                        {editable ? (
                          this.getFilterFieldFromAttribute(index, attribute)
                        ) : (
                          <span style={{ fontSize: "0.9rem", fontWeight: 600, wordBreak: "break-word", overflowWrap: "break-word" }}>
                            {value}
                          </span>
                        )}
                      </div>
                      {(editable || this.props.template) && (
                        <a
                          className="ml-3"
                          onClick={() => {
                            let cloned = [...attributes];
                            cloned.splice(index, 1);
                            saveAttributes(cloned);
                          }}
                        >
                          <i className="fa fa-times" />
                        </a>
                      )}
                    </div>
                  </div>
                );
              }}
            />
          </div>
        )}
        {this.state.showLocationForm && (
          <ModalPopup
            title="Add Location"
            onClose={() => this.setState({ showLocationForm: false })}
            keyboard={false}
            backdrop="static"
          >
            <LocationForm
              fullAddress
              saveLocation={(location) => this.onChangeLocation(location)}
              forDrivers
            />
          </ModalPopup>
        )}
      </div>
    );
  }
}

export default AttributesSelector;
